import { UserSettingsItem } from '@/lib/types/user/settings'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// UI State interfaces
interface UIState {
  openMenus: {
    mainNav: boolean
    userMenu: boolean
    notifications: boolean
    search: boolean
    cart: boolean
  }
  dismissedNotifications: string[] // Array of notification IDs
  lastViewedNotification: string
}

export const initialState: UserSettingsItem & UIState = {
  id: '',
  userId: '',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  currency: 'CAD',
  language: 'EN',
  timezone: 'America/Edmonton',
  country: 'CA',
  unitOfMeasure: 'METRIC',
  preferredVehicleDefinitionId: null,
  preferredVehicleDefinition: null,
  openMenus: {
    mainNav: false,
    userMenu: false,
    notifications: false,
    search: false,
    cart: false,
  },
  dismissedNotifications: [],
  lastViewedNotification: '',
  emailNotifications: true,
  pushNotifications: true,
  marketingEmails: false,
  twoFactorEnabled: false,
  enabledNotificationTypes: ['SYSTEM', 'SECURITY', 'APPOINTMENT', 'MESSAGE', 'ALERT'] as any[],
  enabledNotificationChannels: ['websocket', 'email'] as any[],
  notificationFrequency: 'immediate',
  quietHoursStart: null,
  quietHoursEnd: null,
  quietHoursDays: [],
}

export const userPreferences = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    updateSettings: (state, action: PayloadAction<Partial<UserSettingsItem>>) => {
      return { ...state, ...action.payload }
    },
    resetSettings: () => initialState,
    updatePreferredVehicleDefinition: (state, action: PayloadAction<{ id: string | null, definition?: any }>) => {
      state.preferredVehicleDefinitionId = action.payload.id
      state.preferredVehicleDefinition = action.payload.definition || null
    }
  }
})

export const {
  updateSettings,
  resetSettings,
  updatePreferredVehicleDefinition
} = userPreferences.actions

export default userPreferences.reducer

